(function () {
  "use strict";

  var DNB = (window.DNB = window.DNB || {});
  DNB.modules = []; 
  DNB.isLoading = true;
  DNB.loadingComplete = false;

  var loaderState = {
    total: 1,
    done: 0,
    minDuration: 700,
    startTime: Date.now(),
    ready: false,
    initCompleted: false,
    callbacks: [],
    element: null,
    bar: null,
    percent: null,
    initialText: null,
    completeText: null,
    displayProgress: 0,
    progressTween: null,
    lastRenderedProgress: -1,
    actualProgress: 0,
    autoProgress: 0,
    targetProgress: 0,
    tickActive: false,
    lastTick: 0
  };

  var loaderConfig = {
    suppress: false,
    minDuration: loaderState.minDuration,
    revealDelay: 700,
    isHome: false
  };

  var resolveLoaderConfig = function () {
    if (typeof document === "undefined") {
      return;
    }
    var body = document.body;
    if (!body) {
      return;
    }

    var path = window.location && window.location.pathname ? window.location.pathname : "/";
    var normalizedPath = path.replace(/\/+$/, "") || "/";
    var isHome =
      normalizedPath === "/" || normalizedPath === "/tr" || normalizedPath === "/en";
    loaderConfig.isHome = isHome;
    if (!isHome) {
      loaderConfig.suppress = true;
      loaderConfig.minDuration = 0;
      loaderConfig.revealDelay = 0;
      return;
    }
    loaderConfig.suppress = false;
    loaderConfig.minDuration = loaderState.minDuration;
    loaderConfig.revealDelay = 700;
  };

  var ensureLoader = function () {
    if (loaderState.element || typeof document === "undefined") {
      return;
    }
    var existing = document.querySelector("[data-site-loader]");
    if (!existing && document.body) {
      existing = document.createElement("div");
      existing.className = "preloader";
      existing.setAttribute("data-site-loader", "");
      existing.setAttribute("aria-hidden", "true");
      existing.innerHTML =
        '<div class="progress-container"><div class="progress-bar" data-loader-bar></div></div>' +
        '<div class="text-container">' +
        '<div class="loading-text initial" data-loader-text>Loading</div>' +
        '<div class="loading-text complete">Complete</div>' +
        "</div>" +
        '<div class="percentage" data-loader-percent>0</div>';
      document.body.insertBefore(existing, document.body.firstChild);
    }

    if (!existing) {
      return;
    }

    loaderState.element = existing;
    loaderState.bar = existing.querySelector("[data-loader-bar]") || existing.querySelector(".progress-bar");
    loaderState.percent = existing.querySelector("[data-loader-percent]") || existing.querySelector(".percentage");
    loaderState.initialText =
      existing.querySelector("[data-loader-text]") || existing.querySelector(".loading-text.initial");
    loaderState.completeText = existing.querySelector(".loading-text.complete");
  };

  var colorStages = [
    { bg: "rgb(0, 0, 0)", text: "rgb(255, 255, 255)" },
    { bg: "rgb(40, 40, 40)", text: "rgb(120, 120, 120)" },
    { bg: "rgb(120, 120, 120)", text: "rgb(40, 40, 40)" },
    { bg: "rgb(255, 255, 255)", text: "rgb(0, 0, 0)" }
  ];

  var clamp = function (value, min, max) {
    return Math.max(min, Math.min(max, value));
  };

  var parseRgb = function (value) {
    var match = String(value || "").match(/\d+/g);
    if (!match || match.length < 3) {
      return [0, 0, 0];
    }
    return [parseInt(match[0], 10), parseInt(match[1], 10), parseInt(match[2], 10)];
  };

  var lerp = function (start, end, t) {
    return Math.round(start + (end - start) * t);
  };

  var mixRgb = function (from, to, t) {
    return "rgb(" + lerp(from[0], to[0], t) + ", " + lerp(from[1], to[1], t) + ", " + lerp(from[2], to[2], t) + ")";
  };

  var colorStagesRgb = colorStages.map(function (stage) {
    return {
      bg: parseRgb(stage.bg),
      text: parseRgb(stage.text)
    };
  });

  var updateColors = function (progress) {
    if (!loaderState.element) {
      return;
    }
    var clamped = clamp(progress, 0, 100);
    var segment = 100 / colorStagesRgb.length;
    var index = Math.min(colorStagesRgb.length - 1, Math.floor(clamped / segment));
    var nextIndex = Math.min(colorStagesRgb.length - 1, index + 1);
    var localT = segment > 0 ? (clamped - index * segment) / segment : 0;
    if (nextIndex === index) {
      localT = 0;
    }
    var bgColor = mixRgb(colorStagesRgb[index].bg, colorStagesRgb[nextIndex].bg, localT);
    var textColor = mixRgb(colorStagesRgb[index].text, colorStagesRgb[nextIndex].text, localT);

    loaderState.element.style.backgroundColor = bgColor;
    if (loaderState.bar) {
      loaderState.bar.style.backgroundColor = textColor;
    }
    var textTargets = loaderState.element.querySelectorAll(".loading-text, .loading-text .char, .percentage");
    textTargets.forEach(function (el) {
      el.style.color = textColor;
    });
  };

  var applyProgressVisuals = function (progress) {
    var percent = clamp(progress, 0, 100);
    if (loaderState.bar) {
      loaderState.bar.style.width = percent + "%";
    }
    updateColors(percent);
    if (loaderState.percent) {
      var rounded = Math.round(percent);
      if (rounded !== loaderState.lastRenderedProgress) {
        loaderState.lastRenderedProgress = rounded;
        loaderState.percent.textContent = String(rounded);
      }
    }
  };

  var startProgressTicker = function () {
    if (loaderState.tickActive) {
      return;
    }
    loaderState.tickActive = true;
    loaderState.lastTick = window.performance && performance.now ? performance.now() : Date.now();

    var tick = function () {
      if (!loaderState.tickActive) {
        return;
      }
      var now = window.performance && performance.now ? performance.now() : Date.now();
      var delta = Math.max(0, (now - loaderState.lastTick) / 1000);
      loaderState.lastTick = now;

      if (!loaderState.ready) {
        var speed = 18;
        if (loaderState.autoProgress > 70) {
          speed = 8;
        }
        if (loaderState.autoProgress > 88) {
          speed = 4;
        }
        loaderState.autoProgress = Math.min(99, loaderState.autoProgress + speed * delta);
        loaderState.targetProgress = Math.min(99, Math.max(loaderState.autoProgress, loaderState.actualProgress));
      } else {
        loaderState.targetProgress = 100;
      }

      var ease = 1 - Math.exp(-delta * 6);
      loaderState.displayProgress += (loaderState.targetProgress - loaderState.displayProgress) * ease;
      applyProgressVisuals(loaderState.displayProgress);

      if (loaderState.ready && loaderState.displayProgress >= 99.9) {
        loaderState.displayProgress = 100;
        applyProgressVisuals(100);
        loaderState.tickActive = false;
        return;
      }

      window.requestAnimationFrame(tick);
    };

    window.requestAnimationFrame(tick);
  };

  var setLoaderProgress = function (value, immediate) {
    var percent = Math.max(0, Math.min(100, value));
    if (loaderState.progressTween && window.gsap) {
      loaderState.progressTween.kill();
      loaderState.progressTween = null;
    }
    if (window.gsap && !immediate) {
      var start = loaderState.displayProgress;
      var delta = Math.abs(percent - start);
      loaderState.progressTween = window.gsap.to(loaderState, {
        displayProgress: percent,
        duration: Math.max(0.3, delta * 0.02),
        ease: "power1.out",
        onUpdate: function () {
          applyProgressVisuals(loaderState.displayProgress);
        },
        onComplete: function () {
          applyProgressVisuals(loaderState.displayProgress);
        }
      });
    } else {
      loaderState.displayProgress = percent;
      applyProgressVisuals(percent);
    }
  };

  var updateLoaderProgress = function (immediate) {
    var total = Math.max(loaderState.total, 1);
    var percent = (loaderState.done / total) * 100;
    if (!loaderState.ready) {
      percent = Math.min(percent, 99);
    }
    loaderState.actualProgress = percent;
    if (loaderState.ready) {
      setLoaderProgress(100, true);
      return;
    }
    if (immediate && !loaderState.displayProgress) {
      applyProgressVisuals(loaderState.displayProgress);
    }
    startProgressTicker();
  };

  var finishLoader = function () {
    if (loaderState.ready) {
      return;
    }

    loaderState.ready = true;
    DNB.loadingComplete = true;
    DNB.isLoading = false;
    updateLoaderProgress(true);

    var revealDelay = loaderConfig.revealDelay;

    if (loaderState.element) {
      loaderState.element.setAttribute("aria-hidden", "true");
      loaderState.element.classList.add("is-complete");
    }

    window.setTimeout(function () {
      if (loaderState.element) {
        if (window.gsap) {
          window.gsap.to(loaderState.element, {
            autoAlpha: 0,
            yPercent: -6,
            duration: 0.6,
            ease: "power2.inOut",
            onComplete: function () {
              loaderState.element.style.display = "none";
            }
          });
        } else {
          loaderState.element.style.opacity = "0";
          loaderState.element.style.pointerEvents = "none";
          window.setTimeout(function () {
            loaderState.element.style.display = "none";
          }, 300);
        }
      }

      if (document.body) {
        document.body.classList.remove("is-loading");
        document.body.classList.add("is-loaded");
      }

      var callbacks = loaderState.callbacks.slice();
      loaderState.callbacks = [];
      callbacks.forEach(function (callback) {
        try {
          callback();
        } catch (error) {
          console.error("DNB loader callback error", error);
        }
      });
    }, revealDelay);
  };

  var checkLoaderReady = function () {
    if (loaderState.ready || !loaderState.initCompleted) {
      return;
    }
    if (loaderState.done < loaderState.total) {
      return;
    }
    var elapsed = Date.now() - loaderState.startTime;
    var delay = Math.max(0, loaderState.minDuration - elapsed);
    if (delay) {
      window.setTimeout(finishLoader, delay);
    } else {
      finishLoader();
    }
  };

  DNB.registerLoadTask = function (promise) {
    if (!promise || typeof promise.then !== "function") {
      return promise;
    }
    if (loaderState.ready) {
      return promise;
    }
    loaderState.total += 1;
    // console.log("[loader] task registered", { total: loaderState.total, done: loaderState.done });
    updateLoaderProgress();

    promise.finally(function () {
      loaderState.done += 1;
      // console.log("[loader] task completed", { total: loaderState.total, done: loaderState.done });
      updateLoaderProgress();
      checkLoaderReady();
    });

    return promise;
  };

  DNB.onLoadComplete = function (callback) {
    if (typeof callback !== "function") {
      return;
    }
    if (loaderState.ready) {
      callback();
      return;
    }
    loaderState.callbacks.push(callback);
  };

  var markWindowLoaded = function () {
    loaderState.done += 1;
    // console.log("[loader] window load complete", { total: loaderState.total, done: loaderState.done });
    updateLoaderProgress();
    checkLoaderReady();
  };

  if (typeof window !== "undefined") {
    if (document.readyState === "complete") {
      markWindowLoaded();
    } else {
      window.addEventListener("load", markWindowLoaded, { once: true });
    }
  }

  resolveLoaderConfig();
  loaderState.minDuration = loaderConfig.minDuration;

  if (document.body) {
    if (!loaderConfig.suppress) {
      document.body.classList.add("is-loading");
    } else {
      document.body.classList.remove("is-loading");
    }
  }

  ensureLoader();
  if (loaderConfig.suppress && loaderState.element) {
    loaderState.element.style.opacity = "0";
    loaderState.element.style.pointerEvents = "none";
    loaderState.element.style.display = "none";
    loaderState.element.setAttribute("aria-hidden", "true");
  }
  updateLoaderProgress(true);

  DNB.register = function (fn) {
    if (typeof fn === "function") { 
      DNB.modules.push(fn);
    }
  };

  DNB.prepareReveal = function (element) {
    if (!element) {
      return null;
    }

    if (element.dataset.dnbRevealReady === "true") {
      return element.querySelector(".dnb-reveal__inner") || element;
    }

    var inner = document.createElement("span");
    inner.className = "dnb-reveal__inner";
    while (element.firstChild) {
      inner.appendChild(element.firstChild);
    }
    element.appendChild(inner);
    element.classList.add("dnb-reveal");

    var display = window.getComputedStyle(element).display;
    if (display === "block" || display === "flex" || display === "grid") {
      element.classList.add("dnb-reveal--block");
    } else if (display === "inline") {
      element.classList.add("dnb-reveal--inline");
    }

    element.dataset.dnbRevealReady = "true";
    return inner;
  };

  var wrapRevealV3Word = function (word) {
    if (!word || !word.parentNode) {
      return;
    }

    if (
      word.parentNode.classList &&
      word.parentNode.classList.contains("dnb-text-v3-mask")
    ) {
      return;
    }

    var mask = document.createElement("span");
    mask.className = "dnb-text-v3-mask";
    word.parentNode.insertBefore(mask, word);
    mask.appendChild(word);
  };

  var ensureRevealV3Words = function (target) {
    if (!target || !window.Splitting) {
      return [];
    }

    var hasWords = target.querySelector(".word");
    if (!hasWords) {
      if (!target.hasAttribute("data-splitting")) {
        target.setAttribute("data-splitting", "words");
      }
      window.Splitting({ target: target, by: "words" });
    }

    var words = Array.prototype.slice.call(target.querySelectorAll(".word"));
    if (!words.length) {
      return [];
    }

    words.forEach(wrapRevealV3Word);
    return Array.prototype.slice.call(target.querySelectorAll(".dnb-text-v3-mask .word"));
  };

  var revealV3EaseCache = null;
  var resolveRevealV3Ease = function () {
    if (revealV3EaseCache) {
      return revealV3EaseCache;
    }

    if (window.CustomEase && typeof window.CustomEase.create === "function") {
      revealV3EaseCache = window.CustomEase.create(
        "dnbRevealTextV3Ease",
        "M0,0 C0.625,0.05 0,1 1,1"
      );
      return revealV3EaseCache;
    }

    revealV3EaseCache = "power3.out";
    return revealV3EaseCache;
  };

  DNB.revealText = function (elements, options) {
    var list = [];
    if (typeof elements === "string") {
      list = Array.prototype.slice.call(document.querySelectorAll(elements));
    } else if (elements && elements.length !== undefined) {
      list = Array.prototype.slice.call(elements);
    } else if (elements) {
      list = [elements];
    }

    var runAfterLoad = function (callback) {
      if (typeof callback !== "function") {
        return;
      }
      if (!DNB.loadingComplete && typeof DNB.onLoadComplete === "function") {
        DNB.onLoadComplete(callback);
        return;
      }
      callback();
    };

    if (!window.gsap || !list.length) {
      if (options && typeof options.onComplete === "function") {
        runAfterLoad(options.onComplete);
      }
      return null;
    }

    var targets = list
      .map(DNB.prepareReveal)
      .filter(function (item) {
        return !!item;
      });

    if (!targets.length) {
      if (options && typeof options.onComplete === "function") {
        runAfterLoad(options.onComplete);
      }
      return null;
    }

    var settings = options || {};
    var itemStagger = settings.stagger !== undefined ? settings.stagger : 0.13;
    var duration = settings.duration !== undefined ? settings.duration : 0.8;
    var wordStagger =
      settings.wordStagger !== undefined
        ? settings.wordStagger
        : typeof window.matchMedia === "function" &&
            window.matchMedia("(max-width: 640px)").matches
          ? 0.028
          : 0.025;
    var ease = resolveRevealV3Ease();
    var delay = settings.delay || 0;
    var timeline = window.gsap.timeline({
      delay: delay,
      onComplete: settings.onComplete
    });

    targets.forEach(function (target, index) {
      var maskedWords = ensureRevealV3Words(target);
      var position = index * itemStagger;

      window.gsap.set(target, {
        x: 0,
        y: 0,
        yPercent: 0,
        rotate: 0,
        opacity: 1
      });
      target.setAttribute("data-dnb-reveal-v3-ready", "true");

      if (!maskedWords.length) {
        timeline.fromTo(
          target,
          { y: 20, opacity: 0 },
          {
            y: 0,
            opacity: 1,
            duration: Math.min(duration, 0.55),
            ease: "power2.out"
          },
          position
        );
        return;
      }

      window.gsap.set(maskedWords, {
        x: 0,
        y: 0,
        yPercent: 110,
        opacity: 1,
        force3D: true
      });

      timeline.to(
        maskedWords,
        {
          x: 0,
          y: 0,
          yPercent: 0,
          duration: duration,
          ease: ease,
          stagger: {
            each: wordStagger,
            from: "start"
          }
        },
        position
      );
    });

    if (!DNB.loadingComplete && typeof DNB.onLoadComplete === "function") {
      timeline.pause(0);
      DNB.onLoadComplete(function () {
        timeline.play(0);
      });
    }

    return timeline;
  };

  DNB.prefersReducedMotion = false;

  DNB.init = function () {
    if (DNB._initCalled) {
      return;
    }
    DNB._initCalled = true;

    if (window.gsap && window.ScrollTrigger) {
      window.gsap.registerPlugin(window.ScrollTrigger);
    }

    DNB.modules.forEach(function (module) {
      try {
        module();
      } catch (error) {
        console.error("DNB module error", error);
      }
    });

    loaderState.initCompleted = true;
    checkLoaderReady();

    if (window.DNB && window.DNB.locoScroll && typeof window.DNB.locoScroll.update === "function") {
      window.DNB.locoScroll.update();
    } else if (window.ScrollTrigger) {
      window.ScrollTrigger.refresh();
    }

    if (typeof DNB.onLoadComplete === "function") {
      DNB.onLoadComplete(function () {
        if (window.DNB && window.DNB.locoScroll && typeof window.DNB.locoScroll.update === "function") {
          window.DNB.locoScroll.update();
        } else if (window.ScrollTrigger) {
          window.ScrollTrigger.refresh();
        }
      });
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", DNB.init);
    window.addEventListener("load", DNB.init);
  } else {
    DNB.init();
  }
})();
